var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"pa-6 mt-4 round-xl",attrs:{"outlined":""}},[_c('sharing-qr-code')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }